import { render, staticRenderFns } from "./component-text-link.vue?vue&type=template&id=16423751&"
import script from "./component-text-link.vue?vue&type=script&lang=js&"
export * from "./component-text-link.vue?vue&type=script&lang=js&"
import style0 from "./component-text-link.vue?vue&type=style&index=0&id=16423751&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports